import React, { useEffect, useState } from "react";
import * as httpClient from "../../util/httpClient";
import RegistrationComponents from "./RegistrationComponents";
import { useLocation, BrowserRouter as Router, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as ConfigurationActions from "../../store/configurationService/actions";
import RegistrationError from "./RegistrationError";
import { ApplicationState } from "../../store";
import { useTranslation } from "react-i18next";
import { InactiveUserPopup } from "../../InactiveUserPopup";

const Registration = (props: any) => {
    const [getSessionData, setSessionData] = useState(false);
    const [isError, setIsError] = useState(false);
    const [logoHTML, setLogoHTML] = useState("");
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const LookupValue: any = query.get("VALUE");
    const LookupType: any = query.get("Type");
    const PSSValue = query.get("GNDNRLL");
    const RetailerCode: any = query.get("RetailerCode") || query.get("RETAILERCODE");
    const ProgramSegment = query.get("ProgramSegment");
    const GroupId = query.get("GroupId");
    const SubType = query.get("SUBTYPE");
    const LicenseLimit = query.get("LICENSELIMIT");
    let footerLogoHTML: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.footerLogoHTML
            : ""
    );
    const isTypeSSOProvisional = LookupType === "SSO_PROVISIONAL";
    const PrefixKey: any = query.get("PrefixKey") || query.get("PREFIXKEY");

    const history = useHistory();
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const isInfodefenderId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 544
                ? true
                : false
            : false
    );
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );
    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );
    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    );
    const isIDFUser = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig) {
            if (
                state.configurationState.configuration.partnerConfig.partnerId === 536 ||
                state.configurationState.configuration.partnerConfig.partnerProvider === "IDF"
            ) {
                return true;
            }
        } else {
            return false;
        }
    });

    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const isIDFPartner: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isIdfPartner
            ? state.configurationState.configuration.partnerConfig.isIdfPartner
            : false
    );

    const dispatch = useDispatch();
    const requesPartnerConfig = () => dispatch(ConfigurationActions.actionCreators.requestPartnerConfig(RetailerCode, LookupType, LookupValue));
    const partnerConfigData = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig) {
            return {
                supportInternational: state.configurationState.configuration.partnerConfig.supportInternational,
                registration: state.configurationState.configuration.partnerConfig.registration,
            };
        }
    });
    const requestCountryList = () => dispatch(ConfigurationActions.actionCreators.requestCountryList(isIDFPartner,partnerID));
    const [registrationLookup, setegistrationLookup] = useState();
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    const isOneTrustPartner = useSelector((state: ApplicationState) => {
        const partnerId = state.configurationState?.configuration?.partnerConfig?.partnerId;
        return partnerId != null && [2649, 1557].includes(partnerId);
    });

    useEffect(() => {
        if (isOneTrustPartner) {
            var cookiePrefIcon = document.getElementById('onetrust-consent-sdk');
            if (cookiePrefIcon != null) {
                cookiePrefIcon.remove();
            }
            var cdnScript = document.createElement("script");
            cdnScript.setAttribute("src", "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js");
            cdnScript.setAttribute("type", "text/javascript");
            cdnScript.setAttribute("charSet", "UTF-8");
            cdnScript.setAttribute("data-domain-script", "0191c174-bd6a-7b60-a80c-64c37644ffc1");
            document.getElementsByTagName("body")[0].appendChild(cdnScript);
            var script = document.createElement("script");
            script.setAttribute("type", "text/javascript");
            document.getElementsByTagName("body")[0].appendChild(script);
            var optanonWrapper = "function OptanonWrapper() { }";
            script.innerHTML = optanonWrapper;
            return () => {
                document.body.removeChild(cdnScript);
                document.body.removeChild(script);
            }
        }
    }, []);

    useEffect(() => {
        const requestBody = {
            LookupValue,
            LookupType,
            PSSValue,
            RetailerCode,
            ProgramSegment,
            SubType,
            GroupId,
            LicenseLimit,
            PrefixKey
        };
        requesPartnerConfig();
        requestCountryList();
        if (footerLogoHTML) {
            const domParser = new DOMParser();
            const parsedDoc = domParser.parseFromString(footerLogoHTML, 'text/html');
            let imgElements = parsedDoc.querySelectorAll('img');
            imgElements?.forEach(img => {
                if (!img.hasAttribute('alt')) {
                    img.setAttribute('alt', 'Logo');
                }
            });
            footerLogoHTML = parsedDoc.documentElement.innerHTML;
            setLogoHTML(footerLogoHTML);
        }
        httpClient.sendRequest("POST", "web/partner/getPSSRegistraionLookup", requestBody).then((data: any) => {
            if (!data.isSuccess) {
                if (isIDFUser || isLife360PartnerId) {
                    history.push("/login");
                } else if (!data.isActivationLinkValid) {
                    history.push("/link-expiry", { linkMessage: "Your registration link is no longer valid." });
                } else {
                    setIsError(true);
                }
            } else {
                setegistrationLookup(data);
            }
            setSessionData(true);
        });
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <div>
            {!isError ? (
                <div id="l-page-content">
                    {isTypeSSOProvisional && <InactiveUserPopup {...props} fromRegistration />}
                    <div className={`l-page-container ${!getSessionData && "loading"}`}>
                        <div className=" row">
                            <div className="col-xs-12">
                                <h1 className="title-page" id="title-page">
                                    {isInfodefenderId
                                        ? tLang("registration.dashboardAcessTitle")
                                        : (isAvastId || isAVGId || isAVGTestId)
                                            ? "Create your Identity Protection Profile"
                                            : tLang("registration.title")}
                                </h1>
                            </div>
                        </div>
                        {getSessionData && <RegistrationComponents registrationLookup={registrationLookup} />}

                        {/*{partnerConfigData?.registration && partnerConfigData.registration.hideTripleLayerDefense ? (*/}
                        {/*    <></>*/}
                        {/*) : (*/}
                        {/*    <div className="security-session">*/}
                        {/*        <div className="security-image">*/}
                        {/*            <img*/}
                        {/*                src="data:image/png;base64,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"*/}
                        {/*                alt="Lock Graphic"*/}
                        {/*            />*/}
                        {/*        </div>*/}
                        {/*        <div className="security-text">{tLang("registration.tripleLayerFooter")}&#8480;</div>*/}
                        {/*    </div>*/}
                        {/*)}*/}
                        <></>
                    </div>
                    <div className="logo-container" dangerouslySetInnerHTML={{ __html: logoHTML }}></div>
                </div>
            ) : (
                <RegistrationError />
            )}
        </div>
    );
};

export default Registration;
